module.exports = __webpack_public_path__ + "static/img/Brees-500TDs-Milestone-Selective.982b60e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Brees-500TDs-Milestone-Selective.gif
// module id = qTCb
// module chunks = 1